import { init, track } from '@plausible-analytics/tracker/plausible.js'

const DEFAULT_PLAUSIBLE_DOMAINS: Record<string, string> = {
  production: 'app.core-value.ch',
  test: 'widget.core-value.dev',
}

let initialized = false

export function initPlausibleAnalytics(): void {
  const enabled = import.meta.env.VITE_PLAUSIBLE_ENABLED ?? String(import.meta.env.PROD)

  if (enabled !== 'true') {
    console.info('[Plausible] Disabled')
    return
  }

  if (initialized) return

  const domain =
    import.meta.env.VITE_PLAUSIBLE_DOMAIN ||
    DEFAULT_PLAUSIBLE_DOMAINS[import.meta.env.MODE] ||
    DEFAULT_PLAUSIBLE_DOMAINS.production
  const endpoint = import.meta.env.VITE_PLAUSIBLE_ENDPOINT || undefined

  init({
    domain,
    endpoint,
    autoCapturePageviews: true,
    captureOnLocalhost: import.meta.env.VITE_PLAUSIBLE_CAPTURE_LOCALHOST === 'true',
    bindToWindow: true,
  })

  initialized = true
  console.info('[Plausible] Enabled', { domain })
  trackAppOpened()
}

export function trackPlausibleEvent(eventName: string, interactive = true): void {
  if (!initialized) return

  track(eventName, { interactive })
}

export function trackAppOpened(): void {
  trackPlausibleEvent('app_opened', false)
}

export function trackSummaryViewed(): void {
  trackPlausibleEvent('summary_viewed')
}

export function trackPdfDownloaded(): void {
  trackPlausibleEvent('pdf_downloaded')
}

export function trackFeedbackSent(): void {
  trackPlausibleEvent('feedback_sent')
}
